import EditQuestionIcon from "../assets/images/create-exam/edit-questions.svg";
import PublishIcon from "../assets/images/create-exam/preview-publish.svg";
import TestSettingsIcon from "../assets/images/create-exam/test-settings.svg";
import TestSetupIcon from "../assets/images/create-exam/test-setup.svg";
import UploadQuestionsIcon from "../assets/images/create-exam/upload-questions.svg";


export const formSteps = [
	{
		step: 1,
		title: "Test Setup",
		Icon: TestSetupIcon,
	},
	{
		step: 2,
		title: "Input Questions",
		Icon: UploadQuestionsIcon,
	},
	{
		step: 3,
		title: "Edit Questions",
		Icon: EditQuestionIcon,
	},
	{
		step: 4,
		title: "Test Settings",
		Icon: TestSettingsIcon,
	},
	{
		step: 5,
		title: "Finalize and Publish",
		Icon: PublishIcon,
	},
];
